import React, { FC, useMemo } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { StepLayout } from 'components/StepLayout/StepLayout';
import { useGenerateProduct } from 'hooks/useGenerateProduct';
import { CreateProductStepForm } from './components/CreateProductStepForm';
import { useProductStore } from 'stores/product';
import { biEvents } from 'api/bi-events';
import { StepId } from 'config/flow';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi-events';

export const CreateProductFormStep: FC = () => {
  const { t } = useTranslation();

  const productName = useProductStore((state) => state.productName);
  const productPrice = useProductStore((state) => state.productPrice);
  const isMediaLoading = useProductStore((state) => state.isMediaLoading);

  const { matchCategory, isPendingMatchCategory } = useGenerateProduct({});

  const isNextEnabled = useMemo(() => {
    return !!productName && !!productPrice && !isMediaLoading;
  }, [productName, productPrice, isMediaLoading]);

  return (
    <StepLayout
      disclaimer={t('create-product-step.ai-disclaimer')}
      description={t('create-product-step.description')}
      title={t('create-product-step.title')}
      overrideNext={async (next) => {
        await matchCategory(productName);
        next();
      }}
      onNext={() => {
        const { productName: name, productPrice: price, productDescription } = useProductStore.getState();
        useProductStore.setState({ shouldAddSingleProductToStore: true });
        biEvents.actionClicked({
          value: JSON.stringify({ name, price, description: productDescription }),
          screenName: BI_STEP_NAME[StepId.CreateProductForm],
          action: BI_ACTION_NAME.NEXT,
        });
      }}
      nextButtonProps={{
        label: t('create-product-step.actions.next-button'),
        isLoading: isPendingMatchCategory,
        disabled: !isNextEnabled,
      }}
    >
      <CreateProductStepForm />
    </StepLayout>
  );
};
